import { textEllipsis } from '@design-system/styles'
import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

import { DROPDOWN_DEFAULT_BUTTON_CONTENTS_CLASSNAME } from '@/component/molecules/Dropdown/Dropdown'

const S = {
  StudentNameBox: css`
    display: flex;
    flex-direction: column;

    margin-bottom: 24px;
    padding: 16px;
    border: 1px solid var(--Colors-Gray-300);
    border-radius: var(--Radius-200);

    background: #fff;

    .error > button {
      border: 1px solid var(--Colors-Red-500);
    }

    .error-message {
      color: var(--Colors-Red-500);
      ${typo.caption01};
      margin-top: 4px;
    }
  `,
  StudentNameHeader: css`
    display: flex;
    gap: 24px;
    align-items: center;

    > .title {
      display: flex;
      flex-direction: column;

      font-weight: 700;
      ${typo.body02};

      > span {
        width: 107px;
      }

      > .count {
        color: var(--Colors-Gray-600);
        font-weight: 400;
        ${typo.caption01};
      }
    }

    > .radio-group {
      display: flex;
      gap: 24px;

      label {
        height: 21px;
      }
    }
  `,

  StudentNameDivider: css`
    width: 100%;
    height: 1px;
    background: var(--Colors-Gray-300);
    margin: 16px 0 18px 0;
    border: none;
  `,

  StudentNameSelectRow: css`
    display: flex;
    align-items: center;
    gap: 8px;

    .dropdown {
      width: 320px;
      min-width: 200px;
      max-width: 360px;
    }

    .${DROPDOWN_DEFAULT_BUTTON_CONTENTS_CLASSNAME} .dropdown-item-children {
      > p {
        ${textEllipsis(1)};
      }

      .dropdown-item-badge {
        display: none;
      }
    }
  `,

  DropdownItemChildren: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    flex: 1;

    > p {
      flex: 1;
      ${textEllipsis(2)};
    }
  `,

  StudentNameDesc: css`
    margin-top: 8px;

    text-align: center;
    color: var(--Colors-Gray-600);
    ${typo.caption01};
  `,
  // 열릴 때와 라디오를 바꿀 때 한 번씩 — 위에서 내려오며 등장(240ms), Orange-100 띠가 한 번 훑는다(1100ms).
  // 띠 폭이 50% 라 위치 퍼센트를 -100%→200% 로 둬야 시작·끝에 띠 조각이 남지 않는다.
  // 반복하면 인쇄 설정을 고르는 동안 시선을 빼앗아 끝나면 멈춘다.
  // emotion keyframes 보간이 이 앱 빌드에서 스타일을 통째로 잃는 경우가 있어 이름 있는 @keyframes 를 직접 둔다
  QrNotice: css`
    @keyframes mf-qr-notice-in {
      from {
        opacity: 0;
        transform: translateY(-4px);
      }
      to {
        opacity: 1;
        transform: none;
      }
    }
    @keyframes mf-qr-notice-sweep {
      from {
        background-position: -100% 0;
      }
      to {
        background-position: 200% 0;
      }
    }
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin: 12px 0 0;
    padding: 8px 12px;
    border-radius: var(--Radius-100);
    /* shorthand 를 쓰면 훑기 띠(background-image)가 지워진다 */
    background-color: var(--Colors-Orange-50);
    background-image: linear-gradient(
      90deg,
      transparent 0%,
      var(--Colors-Orange-100) 50%,
      transparent 100%
    );
    background-size: 50% 100%;
    background-repeat: no-repeat;
    color: var(--Colors-Orange-600);
    font-weight: 700;
    ${typo.caption01};
    animation:
      mf-qr-notice-in 240ms ease-out,
      mf-qr-notice-sweep 1100ms ease-in-out 240ms 1 both;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      background-image: none;
    }
  `,
  // QR 아이콘 위를 Orange-400 선이 위아래로 두 번 지나간다
  QrNoticeIcon: css`
    @keyframes mf-qr-notice-icon-scan {
      0% {
        top: 0;
        opacity: 0;
      }
      15% {
        opacity: 1;
      }
      50% {
        top: calc(100% - 2px);
      }
      85% {
        opacity: 1;
      }
      100% {
        top: 0;
        opacity: 0;
      }
    }
    position: relative;
    display: inline-flex;
    flex-shrink: 0;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: -2px;
      left: -2px;
      height: 2px;
      border-radius: var(--Radius-100);
      background: var(--Colors-Orange-400);
      opacity: 0;
      animation: mf-qr-notice-icon-scan 900ms ease-in-out 240ms 2;
    }

    @media (prefers-reduced-motion: reduce) {
      &::after {
        animation: none;
      }
    }
  `,
  QrNoticeBare: css`
    margin-top: 16px;
  `,
}

export default S
